var _defs, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRedeemSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290.92 290.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 29.77px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #ffc557;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n        stroke-width: 29.77px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 145.46,
    cy: 145.46,
    r: 130.58
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "79.46 161.97 116.03 198.54 211.46 103.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedeemSuccess);
export default __webpack_public_path__ + "static/media/icon-redeem_success.80cf798bc20f04147790e7f1b6419e08.svg";
export { ForwardRef as ReactComponent };